import React from 'react';
import { useNavigate } from 'react-router-dom';

// Internal, platform-admin-only honest competitive benchmark (2026).
// Mirrors /app/memory/PITCH_DECK_INVESTORS.md competitive section.

const COLS = [
  'शिक्षा मित्र', 'School Diary', 'Teachmint', 'Classplus', 'Entab CampusCare', 'Fedena', 'MyClassboard',
];

// mark: 'full' | 'basic' | 'none' | 'addon' | string(text)
const ROWS = [
  { label: 'कीमत (indicative)', vals: ['एक-बार ₹4999 + ₹999/yr', '~₹9,999/yr', '₹48k–1.2L', '~₹24k+', '₹3–10L (yr1)', '₹60k–1.1L', 'Custom'] },
  { label: 'Setup fee / onboarding', vals: ['₹0 · self-serve', 'Low', 'Low–Mid', 'Low', '₹75k–2.5L', 'Low', 'Mid'] },
  { label: 'Hindi-first / bilingual UI', vals: ['full', 'basic', 'basic', 'basic', 'basic', 'basic', 'basic'] },
  { label: 'AI Growth Advisor — Aayush (chat+voice)', vals: ['full', 'none', 'basic', 'basic', 'none', 'none', 'basic'] },
  { label: 'In-app guided demo — Diksha', vals: ['full', 'none', 'none', 'none', 'none', 'none', 'none'] },
  { label: 'Lead CRM + lead scoring', vals: ['full', 'none', 'basic', 'full', 'none', 'none', 'full'] },
  { label: 'WhatsApp drip / Geo-fence marketing', vals: ['full', 'addon', 'basic', 'basic', 'none', 'none', 'basic'] },
  { label: 'Admission automation / CRM', vals: ['full', 'none', 'basic', 'basic', 'full', 'full', 'full'] },
  { label: 'Student/Teacher records (SIS)', vals: ['full', 'full', 'full', 'basic', 'full', 'full', 'full'] },
  { label: 'App-based attendance', vals: ['full', 'full', 'full', 'basic', 'full', 'full', 'full'] },
  { label: 'Biometric / RFID attendance (hardware)', vals: ['none', 'full', 'basic', 'none', 'full', 'addon', 'full'] },
  { label: 'Exams + report cards (CBSE/ICSE)', vals: ['basic', 'full', 'basic', 'basic', 'full', 'full', 'full'] },
  { label: 'Fees + online payment', vals: ['full', 'full', 'full', 'full', 'full', 'full', 'full'] },
  { label: 'Timetable', vals: ['full', 'full', 'basic', 'none', 'full', 'full', 'full'] },
  { label: 'Transport module', vals: ['basic', 'full', 'basic', 'none', 'full', 'full', 'full'] },
  { label: 'Real-time GPS bus tracking (hardware)', vals: ['none', 'full', 'none', 'none', 'full', 'addon', 'full'] },
  { label: 'Live bus/CCTV camera streaming', vals: ['none', 'full', 'none', 'none', 'basic', 'none', 'basic'] },
  { label: 'Hostel management', vals: ['none', 'basic', 'basic', 'none', 'full', 'full', 'basic'] },
  { label: 'Payroll / HR / double-entry accounting', vals: ['none', 'basic', 'basic', 'none', 'full', 'full', 'basic'] },
  { label: 'Library', vals: ['full', 'basic', 'basic', 'none', 'full', 'full', 'full'] },
  { label: 'Parent communication (rich/multimedia)', vals: ['basic', 'full', 'full', 'full', 'full', 'full', 'full'] },
  { label: 'Live online classes / LMS', vals: ['none', 'full', 'full', 'full', 'basic', 'addon', 'basic'] },
  { label: 'Homework / lesson plan / class diary', vals: ['basic', 'full', 'full', 'full', 'full', 'full', 'full'] },
  { label: 'Reports & analytics', vals: ['full', 'full', 'full', 'full', 'full', 'full', 'full'] },
  { label: 'Data export (CSV/Excel/PDF)', vals: ['full', 'basic', 'basic', 'basic', 'full', 'full', 'full'] },
  { label: 'Native mobile apps (iOS + Android)', vals: ['none', 'full', 'full', 'full', 'full', 'full', 'full'] },
  { label: 'NEP 2020 / CBSE compliance depth', vals: ['basic', 'basic', 'basic', 'none', 'full', 'basic', 'full'] },
  { label: 'Multi-campus / multi-school', vals: ['basic', 'full', 'full', 'basic', 'full', 'full', 'full'] },
  { label: 'AI-generated marketing videos', vals: ['full', 'none', 'none', 'basic', 'none', 'none', 'none'] },
  { label: 'Self-serve free trial (WhatsApp login)', vals: ['full', 'basic', 'basic', 'basic', 'none', 'basic', 'basic'] },
  { label: 'Market maturity (schools/countries)', vals: ['basic', 'full', 'full', 'full', 'full', 'full', 'full'] },
];

const FREE_TIER = [
  { p: 'Teachmint Free', give: 'Teacher+Admin app, AI whiteboard, unlimited live classes (max 100/class), unlimited storage, EduAI assistant, quizzes/recap', limit: 'मुख्यतः teaching/LMS — full ERP (finance/transport/hostel) नहीं' },
  { p: 'Fedena Open Source', give: '50+ modules free — admission, timetable, exams, HR+payroll, attendance, records, comm, basic fees, multi-login', limit: 'Self-hosted (server + tech team ज़रूरी); premium plugins + support paid' },
  { p: 'Google Classroom (Edu Fundamentals)', give: 'Free — assignments, course creation, Drive sharing, stream/announcements, chat', limit: 'ERP नहीं (no fees/attendance/transport/report-cards); advanced AI paid' },
  { p: 'Generic free India ERPs', give: 'admission, attendance (कभी biometric), fee, timetable, exam, parent comm, roles', limit: 'अक्सर ads/freemium hook; depth व support सीमित' },
  { p: 'School Diary / Entab / MyClassboard / Classplus', give: 'कोई असली free full-tier नहीं — सिर्फ़ demo/trial', limit: 'पूरा उपयोग paid' },
  { p: 'शिक्षा मित्र', give: '100% free base + AI growth engine (Aayush+Diksha+Lead CRM+WhatsApp/Geo-fence+AI videos) + core ERP + self-serve cloud', limit: 'कमज़ोर: live classes/LMS नहीं, native mobile app नहीं, hardware (GPS/biometric) नहीं' },
];

const GAPS = [
  'Native mobile apps (iOS+Android) — लगभग हर बड़ा player के पास; हमारा web-only (सबसे बड़ा gap)',
  'Hardware: real-time GPS bus tracking, biometric/RFID attendance, live CCTV',
  'Deep academics: CBSE/ICSE report-card formats, live classes/LMS, homework/lesson-plan depth',
  'Operations depth: Hostel + Payroll/HR/double-entry accounting',
  'Rich parent-communication / parent "Super App"',
  'Market trust & maturity — case studies + references (हम ~40 स्कूल; वे 700+/कई देश)',
];

const MOAT = [
  'AI-native growth engine — Aayush (chat+voice) + Diksha (guided demo) + Lead CRM + WhatsApp/Geo-fence + admission automation + AI marketing videos',
  'सबसे किफ़ायती one-time pricing (₹4999 lifetime + ₹999/yr) + BYOK (आपकी अपनी key/DB) — कोई recurring per-student charge नहीं + minutes-में self-serve onboarding',
  'Hindi-first अनुभव — Tier-2/3 व coaching institutes के लिए',
];

const MARK = {
  full: { icon: '✅', cls: 'text-emerald-600', bg: 'bg-emerald-50' },
  basic: { icon: '⚠️', cls: 'text-amber-600', bg: 'bg-amber-50' },
  none: { icon: '❌', cls: 'text-rose-600', bg: 'bg-rose-50' },
  addon: { icon: '➕', cls: 'text-sky-600', bg: 'bg-sky-50' },
};

function Cell({ v, primary }) {
  const m = MARK[v];
  if (!m) {
    return <td className={`px-3 py-2 text-xs whitespace-nowrap ${primary ? 'font-bold text-indigo-700 bg-indigo-50/60' : 'text-slate-600'}`}>{v}</td>;
  }
  return (
    <td className={`px-3 py-2 text-center ${primary ? m.bg : ''}`}>
      <span className={`text-sm ${m.cls}`} title={v}>{m.icon}</span>
    </td>
  );
}

export default function CompetitionComparisonPage({ user }) {
  const navigate = useNavigate();

  if (user?.role !== 'platform_admin') {
    return (
      <div className="mx-auto max-w-3xl p-10 text-center" data-testid="competition-denied">
        <i className="fa-solid fa-lock text-4xl text-slate-300"></i>
        <h1 className="mt-4 text-xl font-bold text-slate-800">केवल Platform Admin के लिए</h1>
        <p className="mt-2 text-sm text-slate-500">यह internal competitive analysis सिर्फ़ platform admin देख सकता है।</p>
        <button onClick={() => navigate('/documents')} className="mt-6 rounded-full bg-slate-800 px-5 py-2 text-sm font-semibold text-white" data-testid="competition-back-btn">
          Documents पर वापस
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-6" data-testid="competition-comparison-page">
      <button onClick={() => navigate('/documents')} className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-800" data-testid="competition-back-btn">
        <i className="fa-solid fa-arrow-left"></i> Documents
      </button>

      <div className="rounded-3xl bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-700 p-6 text-white shadow-lg">
        <span className="rounded-full bg-white/15 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white/80">Internal · Platform Admin only</span>
        <h1 className="mt-3 text-3xl font-black">Competitive Benchmark — ईमानदार तुलना (2026)</h1>
        <p className="mt-2 max-w-3xl text-sm text-white/85">
          इसमें वे features भी शामिल हैं जो अभी शिक्षा मित्र में नहीं हैं — ताकि साफ़ पता रहे कि हम कहाँ खड़े हैं और कितना सुधार बाकी है।
          आँकड़े public 2026 sources से indicative हैं।
        </p>
        <div className="mt-4 flex flex-wrap gap-3 text-xs">
          <span className="rounded-full bg-white/10 px-3 py-1">✅ Full</span>
          <span className="rounded-full bg-white/10 px-3 py-1">⚠️ Basic/Partial</span>
          <span className="rounded-full bg-white/10 px-3 py-1">➕ Paid add-on</span>
          <span className="rounded-full bg-white/10 px-3 py-1">❌ Not available</span>
        </div>
      </div>

      {/* Feature matrix */}
      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-bold text-slate-900">📊 Feature-by-feature (named players)</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse text-left" data-testid="competition-matrix">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="sticky left-0 z-10 bg-white px-3 py-2 text-xs font-bold text-slate-700">Feature / Capability</th>
                {COLS.map((c, i) => (
                  <th key={c} className={`px-3 py-2 text-center text-xs font-bold whitespace-nowrap ${i === 0 ? 'text-indigo-700' : 'text-slate-600'}`}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r.label} className="border-b border-slate-100 hover:bg-slate-50/60">
                  <td className="sticky left-0 z-10 bg-white px-3 py-2 text-xs font-medium text-slate-700 whitespace-nowrap">{r.label}</td>
                  {r.vals.map((v, i) => (
                    <Cell key={i} v={v} primary={i === 0} />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Free tier */}
      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-bold text-slate-900">🆓 Competitors की FREE tier में क्या मिलता है</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full text-left text-sm" data-testid="competition-freetier">
            <thead>
              <tr className="border-b border-slate-200 text-xs uppercase text-slate-500">
                <th className="px-3 py-2">Player</th>
                <th className="px-3 py-2">Free में क्या</th>
                <th className="px-3 py-2">बड़ी शर्त / limitation</th>
              </tr>
            </thead>
            <tbody>
              {FREE_TIER.map((f) => (
                <tr key={f.p} className={`border-b border-slate-100 align-top ${f.p === 'शिक्षा मित्र' ? 'bg-indigo-50/50' : ''}`}>
                  <td className={`px-3 py-2 text-xs font-bold whitespace-nowrap ${f.p === 'शिक्षा मित्र' ? 'text-indigo-700' : 'text-slate-800'}`}>{f.p}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">{f.give}</td>
                  <td className="px-3 py-2 text-xs text-slate-500">{f.limit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Verdict */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-emerald-200 bg-emerald-50/60 p-5" data-testid="competition-moat">
          <h3 className="mb-3 flex items-center gap-2 text-base font-bold text-emerald-800"><i className="fa-solid fa-shield-halved"></i> हमारा Moat (जहाँ हम आगे)</h3>
          <ul className="space-y-2 text-sm text-emerald-900">
            {MOAT.map((m, i) => (<li key={i} className="flex gap-2"><span>✅</span><span>{m}</span></li>))}
          </ul>
        </div>
        <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-5" data-testid="competition-gaps">
          <h3 className="mb-3 flex items-center gap-2 text-base font-bold text-rose-800"><i className="fa-solid fa-triangle-exclamation"></i> Improvement needed (priority)</h3>
          <ol className="space-y-2 text-sm text-rose-900">
            {GAPS.map((g, i) => (<li key={i} className="flex gap-2"><span className="font-bold">{i + 1}.</span><span>{g}</span></li>))}
          </ol>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 text-sm text-slate-600" data-testid="competition-summary">
        <b className="text-slate-800">रणनीतिक सार:</b> हम "स्कूल को grow करने वाला AI platform" के रूप में जीतते हैं; ERP-depth व hardware/mobile में बड़े players अभी आगे हैं।
        अगला 2-3 quarter का फोकस: <b>mobile app → GPS/biometric → hostel/payroll → CBSE academics</b>।
        <div className="mt-2 text-xs text-slate-400">Sources: public 2026 pricing/feature data (indicative; custom-quote players की कीमत स्कूल-आकार पर निर्भर)।</div>
      </div>
    </div>
  );
}
